import React from 'react';
import useAppStore from '../../store/useAppStore.js';
import './FilterBar.css';

export default function FilterBar() {
  const { filter, searchQuery, market, setFilter, setSearchQuery, setMarket, tickers } = useAppStore();

  const buyCount = tickers.filter(t => t.buy_count > 0).length;
  const sellCount = tickers.filter(t => t.sell_count > 0).length;

  return (
    <div className="filter-bar">
      <select
        className="market-select"
        value={market}
        onChange={(e) => setMarket(e.target.value)}
      >
        <option value="US">US Stocks</option>
        <option value="IN">Nifty 500</option>
      </select>

      <div className="filter-pills">
        <button
          className={`filter-pill ${filter === 'ALL' ? 'active' : ''}`}
          onClick={() => setFilter('ALL')}
        >
          ALL <span className="pill-count">{tickers.length}</span>
        </button>
        <button
          className={`filter-pill ${filter === 'BUY' ? 'active' : ''}`}
          onClick={() => setFilter('BUY')}
        >
          BUY <span className="pill-count">{buyCount}</span>
        </button>
        <button
          className={`filter-pill ${filter === 'SELL' ? 'active' : ''}`}
          onClick={() => setFilter('SELL')}
        >
          SELL <span className="pill-count">{sellCount}</span>
        </button>
      </div>

      <input
        type="text"
        className="search-input"
        placeholder="Search ticker..."
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
      />
    </div>
  );
}
